import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Bank File Export is built. Reached from
// Payroll > Disbursement > Bank File Export in the sidebar flyout.
export const DisbursementBankFileExport = () => <NotImplemented title="Bank File Export" />;
